import type {
  PostFormat,
  ScheduledPostDto,
  ScheduledPostStatus,
} from "@nlc/shared-types";

import type { Platform } from "../schedule-wizard/post-type-step/postTypes";

export interface ScheduledPost {
  account: {
    location?: string;
    name: string;
  };
  brand: ScheduledPostDto["brand"];
  caption: string;
  errorMessage?: null | string;
  format: PostFormat;
  id: number;
  images: ImageSources[];
  platform: null | Platform;
  scheduledAt: Date;
  status: ScheduledPostStatus;
  title: string;
  video: null | PostVideoSource;
}

// One image's URLs, best first: the resized preview, then the original.
export type ImageSources = string[];

export interface PostVideoSource {
  attachmentId: number;
  extension: string;
  url: string;
}

export function toScheduledPost(dto: ScheduledPostDto): ScheduledPost {
  const { page } = dto;

  return {
    account: { name: page?.username ?? page?.name ?? dto.brand.name },
    brand: dto.brand,
    caption: dto.caption ?? "",
    errorMessage: dto.errorMessage,
    format: dto.format,
    id: dto.id,
    images: dto.designs.flatMap((design) =>
      design.mime.startsWith("image/") && design.url
        ? [[design.previewUrl, design.url].flatMap((url) => (url ? [url] : []))]
        : [],
    ),
    platform:
      page?.platform === "facebook" || page?.platform === "instagram"
        ? page.platform
        : null,
    scheduledAt: new Date(dto.scheduledAt),
    status: dto.status,
    title: dto.name || dto.designs[0]?.name || dto.brand.name,
    video: toVideoSource(dto.designs),
  };
}

function toVideoSource(
  designs: ScheduledPostDto["designs"],
): null | PostVideoSource {
  const video = designs.find((design) => design.mime.startsWith("video/"));

  if (!video?.url) return null;

  return {
    attachmentId: video.id,
    extension: video.mime === "video/quicktime" ? "mov" : "mp4",
    url: video.url,
  };
}
